import { ModalFooter } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import Tooltip from 'components/tooltip/Tooltip';
import { ModalFormSubmitButtonStyled } from './MessageLogViewModal.styles';

interface MessageLogViewModalFooterProps {
  isMigrated: boolean;
  isTriggerDeleted: boolean;
  closeModal: () => void;
}

const MessageLogViewModalFooter = ({
  isMigrated,
  isTriggerDeleted,
  closeModal,
}: MessageLogViewModalFooterProps) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();

  const disableResendButton = isMigrated || isTriggerDeleted;

  const submitButton = (
    <ModalFormSubmitButtonStyled
      disabled={disableResendButton || isSubmitting}
      disabledIfNotDirty={false}
    >
      {isSubmitting
        ? t('pageAutomations.messageLog.modal.resending')
        : t('pageAutomations.messageLog.modal.resend')}
    </ModalFormSubmitButtonStyled>
  );

  return (
    <ModalFooter>
      <ModalFormCancelButton
        disabled={isSubmitting}
        closeOnClick={false}
        onClick={closeModal}
      />
      {isTriggerDeleted ? (
        <Tooltip
          id="trigger-deleted-tooltip"
          text={t('pageAutomations.messageLog.modal.tooltipDeletedTrigger')}
        >
          {submitButton}
        </Tooltip>
      ) : (
        submitButton
      )}
    </ModalFooter>
  );
};

export default MessageLogViewModalFooter;
